import React from 'react';
import * as utils from '../date_utils';
import CalendarWeek from './calendarweek';

const FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;

export default class CalendarMonth extends React.Component {
    isWeekInMonth(startOfWeek) {
        const endOfWeek = utils.addDays(utils.cloneDate(startOfWeek), 6);
        return (
            utils.isSameMonth(startOfWeek, this.props.currentMonth) ||
            utils.isSameMonth(endOfWeek, this.props.currentMonth)
        );
    }

    render() {
        let currentWeekStart = utils.getStartOfWeek(
            utils.getStartOfMonth(utils.cloneDate(this.props.currentMonth))
        );
        const isFixedHeight = false;
        const weeks = [];

        let w = 0;
        let breakAfterNextPush = false;
        while (!breakAfterNextPush) {
            weeks.push(
                <CalendarWeek
                    startWeek={currentWeekStart}
                    key={'M' + this.props.currentMonth.month() + 'W' + currentWeekStart.week()}
                    value={this.props.value}
                    intervals={this.props.intervals}
                    onMonthClick={this.props.onMonthClick}
                    currentWeek={this.props.currentMonth}
                />
            );

            if (breakAfterNextPush) break;

            w++;
            currentWeekStart = utils.addWeeks(utils.cloneDate(currentWeekStart), 1);
            // If one of these conditions is true, we will either break on this week
            // or break on the next week
            const isFixedAndFinalWeek = isFixedHeight && w >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
            const isNonFixedAndOutOfMonth = !isFixedHeight && !this.isWeekInMonth(currentWeekStart);

            if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
                break;
            }
        }

        return <tbody className="body">{weeks}</tbody>;
    }
}
